export default __webpack_public_path__ + "static/media/digital-rafter-logo.77d7c7bb.svg";